import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SummaryPanels = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing(20)};
  margin-bottom: ${({ theme }) => theme.spacing(20)};
`;

export const GeneralPanels = styled.div`
  > * + * {
    margin-top: ${({ theme }) => theme.spacing(20)};
  }
`;

export const ItallicNote = styled.span`
  font-style: italic;
  font-weight: 400;
  margin: 0 6px;
  font-size: 13.5px;
  padding-top: 8px;
`;

export const InternalNotes = styled.div`
  font-size: ${({ theme }) => theme.pxToRem(14)};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  line-height: 1.5;

  > * + * {
    margin-top: ${({ theme }) => theme.spacing(10)};
  }

  span {
    color: ${({ theme }) => theme.colours.charcoalDust};
  }

  p {
    color: ${({ theme }) => theme.colours.crowberryBlue};
  }

  span,
  p,
  a {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  a {
    display: inline-block;
  }
`;

export const CommentsContainer = styled.div`
  font-size: ${({ theme }) => theme.pxToRem(14)};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  margin-top: ${({ theme }) => theme.spacing(8)};
  line-height: 1.5;

  > div {
    margin-top: ${({ theme }) => theme.spacing(6)};
  }

  span {
    color: ${({ theme }) => theme.colours.charcoalDust};
  }

  p {
    color: ${({ theme }) => theme.colours.crowberryBlue};
  }

  span,
  p,
  a {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  a {
    display: inline-block;
  }
`;

// ===== ApprovalStatusPanel =====

export const Card = styled.div`
  position: relative;
  padding: ${({ theme }) => theme.spacing(25)} ${({ theme }) => theme.spacing(20)};
  padding-top: 0;
  border-radius: ${({ theme }) => theme.pxToRem(5)};
  background-color: 'transparent';
  color: ${({ theme }) => theme.colours.black};
`;

export const CTA = styled(Link)`
  position: absolute;
  top: ${({ theme }) => theme.spacing(-10)};
  right: ${({ theme }) => theme.spacing(8)};
  line-height: 1;

  svg {
    color: ${({ theme }) => theme.colours.swimmersPool};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
`;

export const List = styled.dl`
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(6)};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  width: fit-content;

  dt,
  dd {
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-size: ${({ theme }) => theme.pxToRem(14)};
    line-height: 1.7;
  }

  dt {
    color: ${({ theme }) => theme.colours.charcoalDust};
    margin-right: ${({ theme }) => theme.spacing(8)};
    white-space: nowrap;
  }

  dd {
    margin: 0;
    color: ${({ theme }) => theme.colours.crowberryBlue};
    display: inline-flex;
  }
`;

export const CommentsRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  width: 100%;
  max-width: 225px;
  padding: 0;
  font-size: ${({ theme }) => theme.pxToRem(14)};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  line-height: 1.5;
  margin-top: ${({ theme }) => theme.spacing(-6)};

  > dt {
    margin-right: ${({ theme }) => theme.spacing(8)};
    white-space: nowrap;
    color: ${({ theme }) => theme.colours.charcoalDust};
    font-weight: normal;
  }

  > div[data-expanded='false'] {
    display: inline-flex;
    align-items: baseline;
    gap: ${({ theme }) => theme.spacing(4)};
  }

  > div[data-expanded='true'] {
    display: block;
  }

  > div > p {
    margin: 0;
    color: ${({ theme }) => theme.colours.crowberryBlue};
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  > div[data-expanded='false'] > button {
    display: inline;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  > div[data-expanded='true'] > button {
    display: block;
    margin: 0; /* no “empuja” el texto */
  }
`;
